import axios from 'axios';
import qs from 'qs';
import config from '@/config';
import router from '@/router'
import store from '@/store';
import {
  Message
} from 'element-ui';
import wx from 'weixin-js-sdk'

axios.defaults.baseURL = config.api_url;

const instance = axios.create();
instance.interceptors.request.use(
  request => {
    let auth_token = localStorage.getItem('auth_token');
    let invite_code = localStorage.getItem('invite_code');
    let merchant_id = localStorage.getItem('merchant_id');
    request.headers.invitecode = invite_code;
    request.headers.merchantid = merchant_id;
    request.headers.source = config.SOURCE;

    if (auth_token) {
      request.headers.token = auth_token;
    } else {
      request.headers.token = 'ZDE4aDZEZVQyL2RnTE5NZnNoZm96TGczR3dvaTNscHVaTkNsYmpyNXE3aVk4OXpLLzRNcFVkSTBFUFFoZG00R3Z6bG5nd3YvYVZmNERneER0MTBIemc9PQ%3D%3D';
    }

    if (request.url.indexOf('http') == -1) {
      request.data = qs.stringify(request.data || {});
    }

    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {

    if (typeof response.data !== 'object') {
      return Promise.reject(new Error('异常数据,请重试'));
    }

    if (response.data.loginStatus === 1) {
      if (response.data.token) {
        localStorage.setItem('auth_token', response.data.token);
      }
    } else {
      localStorage.removeItem('auth_token');
    }

    let responseUrl = '';
    if (typeof response.request.responseURL != 'undefined') {
      responseUrl = response.request.responseURL;
    } else {
      responseUrl = response.config.url;
    }

    if (responseUrl.indexOf(config.api_url) !== -1) {
      if (response.data.code != 0) {
        return Promise.reject(new Error(response.data.msg));
      }
      return response.data;
    } else {
      return Promise.reject(new Error('异常数据'));
    }
  },
  error => {
    return Promise.reject(error);
  }
);

let api = {};

api.request = (method, data) => {
  return instance.post(method, data);
};

/**
 * [wxRegister 微信Api初始化]
 * @param  {Function} callback [ready回调函数]
 */
api.wxRegister = () => {
  // 这边的接口请换成你们自己的
  Axios.post('https://ccc.wangwanglive.com/index.php/api/v1/getjsapiticket', {
    timeout: 5000,
    withCredentials: true
  }).then((res) => {
    // let data = JSON.parse(res.data.data) // PS: 这里根据你接口的返回值来使用
    console.log(res);

    wx.config({
      debug: false, // 开启调试模式
      appId: 'wxfd5817ed0c222fef', // 必填，公众号的唯一标识
      timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: '' + res.data.data.nonceStr + '', // 必填，生成签名的随机串
      signature: '' + res.data.data.signature + '', // 必填，签名，见附录1
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        'hideOptionMenu', //界面操作接口1
        'showOptionMenu'
      ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })
    wx.ready(() => {
      console.log('wx ready')
    });
    wx.error(function(res) {
      console.log('err', res)
    });

  }).catch((error) => {
    console.log(error)
  })
  wx.ready((res) => {
    // 如果需要定制ready回调方法
    // if (callback) {
    //   callback()
    // }
  })
},
/**
 * [ShareTimeline 微信分享到朋友圈]
 * @param {[type]} option [分享信息]
 * @param {[type]} success [成功回调]
 * @param {[type]} error   [失败回调]
 */
api.ShareTimeline = (option) => {
  wx.onMenuShareTimeline({
    title: option.title, // 分享标题
    link: option.link, // 分享链接
    imgUrl: option.imgUrl, // 分享图标
    success() {
      // 用户成功分享后执行的回调函数
      option.success()
    },
    cancel() {
      // 用户取消分享后执行的回调函数
      option.error()
    }
  })
},
/**
 * [ShareAppMessage 微信分享给朋友]
 * @param {[type]} option [分享信息]
 * @param {[type]} success [成功回调]
 * @param {[type]} error   [失败回调]
 */
api.ShareAppMessage = (option) => {
  console.log(option);
  wx.onMenuShareAppMessage({
    title: option.title, // 分享标题
    desc: option.desc, // 分享描述
    link: option.link, // 分享链接
    imgUrl: option.imgUrl, // 分享图标
    success(res) {
      // 用户成功分享后执行的回调函数
      console.log(res);
      option.success()
    },
    cancel() {
      // 用户取消分享后执行的回调函数
      option.error()
    }

  })
},
api.OptionMenu = (option) => {
  console.log(option);
  if (option == "hideOptionMenu") {
    wx.hideOptionMenu();
  } else {
    wx.showOptionMenu();
  }
}

export default {
  install(Vue) {
    Vue.prototype.$api = api;
  }
};



// WEBPACK FOOTER //
// ./src/util/Api.js